module.exports = __webpack_public_path__ + "img/registration.20d6dabf.svg";